import ObjectsGroupsPage from './container'

export default ObjectsGroupsPage